<template>
  <div :style="companyDynamicStyle">
    <div class="hosting-content-container" v-if="!showSearch">
      <div class="d-flex align-items-center">
        <div class="pl-1 pr-2 home">
          <font-awesome-icon
            @click="
              goToWebTranslatedEntity({
                entityType: 'Knowledge',
                query: { source: 'navigation' },
              })
            "
            :icon="['far', 'home']"
            class="home-btn"
          />
        </div>
        <NavigationBreadcrumb
          :bc-path="navPath"
          class="ml-2 breadcrumbContent"
        />
      </div>
    </div>
    <div v-else class="no-breadcrumb"></div>
    <div class="mw-node-main-card">
      <div class="container-fluid">
        <MaydayNodeMainHeader />
      </div>
      <LoaderLine :loading="loading" />
      <div class="container-fluid">
        <MaydayNodeMainBody @open-feedback-modal="openFeedbackModal" />
        <MaydayNodeMainFooter :bc-path="navPath" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import NavigationBreadcrumb from './NavigationBreadcrumb';
import MaydayNodeMainHeader from './MaydayNodeMainHeader';
import LoaderLine from '@/components/Loaders/LoaderLine';
import MaydayNodeMainBody from './MaydayNodeMainBody/MaydayNodeMainBody';
import MaydayNodeMainFooter from './MaydayNodeMainFooter';

import { fontColorAccordingToBackground } from 'utils/webKnowledgeModule';

export default {
  name: 'mayday-node-main',
  props: {
    companyColor: String,
  },
  components: {
    MaydayNodeMainFooter,
    NavigationBreadcrumb,
    MaydayNodeMainHeader,
    MaydayNodeMainBody,
    LoaderLine,
  },
  computed: {
    ...mapGetters('webKnowledgeModule', [
      'navPath',
      'focusKnowledge',
      'loading',
      'showSearch',
    ]),
    companyDynamicStyle() {
      return {
        '--font-color': fontColorAccordingToBackground(this.companyColor),
      };
    },
  },

  methods: {
    openFeedbackModal(content) {
      this.$emit('open-feedback-modal', content);
    },
    backToHome(e) {
      const routeKnowledgeId = this.$route.params.knowledgeId;
      const knowledgeId = this.focusKnowledge
        ? this.focusKnowledge.id
        : routeKnowledgeId;

      const path = `/web/knowledge/${knowledgeId}`;

      if (e.metaKey || e.ctrlKey) {
        return window.open(path);
      }
      this.$router.push({ path });
    },
    ...mapActions('webKnowledgeModule', ['goToWebTranslatedEntity']),
  },
};
</script>
<style lang="scss" scoped>
.home {
  color: $grey-4-mayday;
  line-height: 1;
  border-right: 1px solid $grey-4-mayday;

  .home-btn {
    cursor: pointer;
  }
}

.no-breadcrumb {
  padding-top: 16px;
}

.mw-node-main-card {
  background-color: white;
  border: 2px solid #f2f6fd;
  border-radius: 4px;
  margin-bottom: 16px;
}

.hosting-content-container {
  width: 100%;
  margin-top: -8px;
  margin-right: auto;
  margin-left: auto;
}

.breadcrumbContent {
  :deep() .mw-node-card-bc-link-last {
    color: var(--font-color) !important;
  }
  :deep() .mw-node-card-bc-link {
    color: var(--font-color) !important;
  }
}
</style>
